import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { RootSaga } from '.';
import { combineReducers } from 'redux'
import { AuthReducer } from './auth/reducer';
import { DocusignReducer } from './docusign/reducer';
import { DownloadsReducer } from './downloads/reducer';
import { InterestReducer } from './interests/reducer';
import { LPReducer } from './lps/reducer';
import { OfferingReducer } from './offerings/reducer';
import { SignupReducer } from './signup/reducer';
import { UserManagementReducer } from './user-management/reducer';
import { ConfigReducer } from './config/reducer';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: combineReducers({
        auth: AuthReducer,
        docusign: DocusignReducer,
        downloads: DownloadsReducer,
        interest: InterestReducer,
        lp: LPReducer,
        offering: OfferingReducer,
        signup: SignupReducer,
        userManagement: UserManagementReducer,
        config: ConfigReducer,
    }),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({immutableCheck: false, serializableCheck: false}).concat(sagaMiddleware)
})

sagaMiddleware.run(RootSaga);